<template>
  <div>
    <appbar :showBorder="true" :dense="true">
      <template v-slot:custom-selectors>
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%; margin-left: 0px; gap: 0px"
        >
          <div
            v-if="
              $route.name === 'helio-clean' &&
              viewMode != 'evolution' &&
              viewMode === 'alarmes'
            "
            class="date_selector_smart"
          >
            <div v-if="isWarningCondition" class="alert-wrapper">
              <v-icon
                @click="showAlert = !showAlert"
                :color="color_warning_msg"
                class="alert-icon"
              >
                mdi-alert
              </v-icon>
              <v-alert
                v-model="showAlert"
                v-show="showAlert"
                type="info"
                dense
                shaped
                dismissible
                :color="color_warning_msg"
                class="alert-popup"
              >
                {{ warning_error_msg }}
              </v-alert>
            </div>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  v-model="dateRange"
                  prepend-icon="mdi-calendar"
                  :color="isDateModified ? 'orange' : 'grey darken-1'"
                  readonly
                  hide-details
                  class="fleet-date-smart"
                  v-bind="attrs"
                  v-on="on"
                  @click="menu = true"
                  @click:prepend="resetToMaxDate()"
                />
              </template>
              <v-date-picker
                v-model="tempDateRange"
                scrollable
                :min="min_date"
                :max="maxDate"
              >
                <v-spacer></v-spacer>
                <v-btn text style="font-size: bold" @click="menu = false"
                  >Annuler</v-btn
                >
                <v-btn text color="primary" @click="takedades"
                  >Rafraichir</v-btn
                >
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </template>
    </appbar>

    <div style="margin-top: 5px">
      <informationSiteClean
        :selected_date="dateRange"
        :list_total="list_dashboard"
        :liste_fleet="list_fleet.data"
        :nbr_site="site"
      />
    </div>
    <div>
      <v-card
        style="
          flex: 1;
          margin-top: 10px;
          margin-left: 20px;
          margin-right: 10px;
          border-top: 10px;
          border-bottom: 0px;
          padding: 10px;
        "
      >
        <div class="btn">
          <v-btn @click="selected_mode_tab_middle = '_planning_de_nettoyage_'">
            {{ $t("_planning_de_nettoyage_") }}
          </v-btn>
          <v-btn @click="selected_mode_tab_middle = '_evolutions_'">
            {{ $t("_evolutions_") }}
          </v-btn>

          <v-btn @click="selected_mode_tab_middle = '_alarmes_'">
            {{ $t("_alarmes_") }}
          </v-btn>
        </div>
      </v-card>
      <div style="display: flex">
        <v-card
          v-if="selected_mode_tab_middle === '_evolutions_'"
          :style="{
            marginRight: '8px',
            marginLeft: '20px',
            backgroundColor: '#f5f5f5',
            border: '5px solid orange',
            borderRadius: '8px',
          }"
          style="
            flex: 1;
            margin-left: 10px;
            border-radius: 0;
            margin-bottom: 20px;
          "
        >
          <evolutionSiteClean :installation_id="Number(cur_install_id)" />
        </v-card>

        <v-card
          v-else-if="selected_mode_tab_middle === '_alarmes_'"
          :style="{
            marginLeft: '20px',
            marginRight: '8px',
          }"
          style="
            flex: 1;
            margin-right: 10px;
            border-radius: 0;
            margin-bottom: 20px;
          "
        >
          <alarmSiteClean
            :liste_alarmes="list_alarms"
            :selected_date="dateRange"
            :nbr_site="site"
            :installation_id="Number(cur_install_id)"
          />
        </v-card>

        <v-card
          v-else-if="selected_mode_tab_middle === '_planning_de_nettoyage_'"
          :style="{
            marginLeft: '20px',
            marginRight: '8px',
          }"
          style="
            flex: 1;
            margin-right: 10px;
            border-radius: 0;
            margin-bottom: 20px;
          "
        >
          <planningSiteClean :installation_id="[Number(cur_install_id)]" />
        </v-card>
      </div>
    </div>
    <div></div>
    <div>
      <v-row class="mb-2 px-4 pb-2">
        <v-col :class="'col-12'">
          <div class="d-flex" style="align-items: center">
            <div
              class="mode-choice"
              v-for="mode in helioModes"
              :key="mode"
              :class="{ active: mode == selected_mode }"
              @click="selected_mode = mode"
            >
              {{ $t(mode) }}
            </div>
          </div>

          <InstallationsSiteClean
            :liste_fleet="list_fleet.data"
            :selected_date="dateRange"
            v-if="selected_mode === '_site_details_'"
          />
          <ExpertImgModule
            v-if="selected_mode === '_masque_'"
            :key="'mask-' + cur_install_id"
            :installationId="cur_install_id"
            moduleName="mask"
          />
          <ExpertImgModule
            v-else-if="selected_mode === '_salissure_apparente_'"
            :key="'soiling-' + cur_install_id"
            :installationId="cur_install_id"
            moduleName="soiling"
          />
          <MainExpert
            v-else-if="expertName"
            :key="expertName"
            :installationId="cur_install_id"
            :expertName="expertName"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import informationSiteClean from "./informationSiteClean.vue";
import Appbar from "@/components/App/Appbar.vue";
import alarmSiteClean from "./alarmSiteClean.vue";
import evolutionSiteClean from "./evolutionSiteClean.vue";
import planningSiteClean from "./planningSiteClean.vue";
import MainExpert from "../../Experts/MainExpert.vue";
import ExpertImgModule from "../../Installations/ExpertImgModule.vue";
import { mapGetters } from "vuex";
import InstallationsSiteClean from "./InstallationsSiteClean";
import api from "@/api/api";
import webconf from "../../../utils/frontend_setup.js";

export default {
  components: {
    Appbar,
    MainExpert,
    ExpertImgModule,
    InstallationsSiteClean,
    informationSiteClean,
    alarmSiteClean,
    evolutionSiteClean,
    planningSiteClean,
  },

  data() {
    return {
      installation: {},
      viewMode: "alarmes",
      selected_mode: "_site_details_",
      modes: [
        "_site_details_",
        "_ombrage_",
        "_salissure_apparente_",
        "_masque_",
      ],
      expertModules: [],
      selected_mode_tab_middle: "_evolutions_",
      modes_tab_middle: ["_evolutions_", "_alarmes_", "_parameters_site_"],
      key_update: 0,
      menu: false,
      menu_two: false,
      isDateModified: false,
      maxDate: new Date(Date.now() - 86400000).toISOString().substr(0, 10), // 86400000 ms = 1 day
      min_date: this.installation?.audit_start_date || "2016-01-01",
      dates: [],
      selectedDate: "",
      dateRange_two: "",
      tempDateRange_two: "",
      color_warning_msg: "orange",
      warning_error_msg: "",
      showAlert: false,
      dateRange: "",
      tempDateRange: "",     
      list_fleet: { data: [] },
      defaultDashboard: {
        nb_de_site: 0,
        pc_totale: 0,
        roi_euro_optim: 0,
        roi_euro_user: 0,
        Fleet_losses_pct: 0,
        Fleet_losses_evolutions_pct: 0,
        Fleet_recoverables_losses_pct: 0,
        Fleet_recoverable_losses_evolutions_pct: 0,
        site_cleaning_freq_optim_short: [],
        site_pruning_freq_optim_short: [],
        roiUserTree: [
          { name: "roi_cleaning_euro_user", value: 0 },
          { name: "roi_pruning_euro_user", value: 0 },
        ],
        roiOptimTree: [
          { name: "roi_cleaning_euro_optim", value: 0 },
          { name: "roi_pruning_euro_optim", value: 0 },
        ],
        Fleet_losses_pct_tree: [
          { name: "Fleet_soiling_losses_pct", value: 0 },
          { name: "Fleet_shading_losses_pct", value: 0 },
        ],
        Fleet_recoverables_losses_pct_tree: [
          { name: "Fleet_soiling_recoverable_losses_pct", value: 0 },
          { name: "Fleet_shading_recoverable_losses_pct", value: 0 },
        ],
        major_alarms: 0,
        minor_alarms: 0,
        without_alarms: 0,
      },
      list_dashboard: {
        nb_de_site: 0,
        pc_totale: 0,
        roi_euro_optim: 0,
        roi_euro_user: 0,
        Fleet_losses_pct: 0,
        Fleet_losses_evolutions_pct: 0,
        Fleet_recoverables_losses_pct: 0,
        Fleet_recoverable_losses_evolutions_pct: 0,
        site_cleaning_freq_optim_short: [],
        site_pruning_freq_optim_short: [],
        roiUserTree: [],
        roiOptimTree: [],
        Fleet_losses_pct_tree: [],
        Fleet_recoverables_losses_pct_tree: [],
        major_alarms: 0,
        minor_alarms: 0,
        without_alarms: 0,
      },
      site: [],
      list_alarms: [],
      checklistStatus: {},
    };
  },

  watch: {
    selected_mode: {
      handler(val) {
        webconf.debugLog(
          "watch",
          this.script_name,
          "selected_mode",
          `mode : ${this.selected_mode}`
        );

        if (val === "_site_details_") {
          this.$root.$emit("close-go-to-site");
        }
      },
      deep: true,
    },

    dateRange_two: {
      handler() {
        webconf.debugLog(
          "watch",
          this.script_name,
          "dates",
          this.$store.state.parametersStore.dates
        );
      },
      immediate: true,
      deep: true,
    },
    $route: {
      handler() {
        if (this.$route.query.selected_date) {
          this.selectedDate = this.$route.query.selected_date;
        }

        if (!this.selectedDate) this.selectedDate = localStorage.date;

        this.setDefaultDateToYesterday();
        this.takedades();
      },
      immediate: true,
      deep: true,
    },

    "$root.$i18n.locale": {
      handler() {
        //this.takedades()
      },
      immediate: true,
      deep: true,
    },
    "$route.params.selected_date": function (newDate) {
      this.selectedDate = newDate;
      if (!this.selectedDate) this.selectedDate = localStorage.date;
      this.setDefaultDateToYesterday();
    },
    cur_install_id: {
      immediate: true,
      async handler(newId) {
        this.installation =
          this.installations.find((x) => x.installation_id === newId) || null;

        if (this.installation) {
          this.initinstallation();
          await this.getReportModules();
        }
      },
    },
  },

  mounted() {
    this.initinstallation();
    this.site.push(this.cur_install_id);
    this.selectedDate = this.$route.query.selected_date || "";

    if (!this.selectedDate) this.selectedDate = localStorage.date;
    this.setDefaultDateToYesterday();
    this.isDateModified = this.dateRange !== this.maxDate;
    this.$store.dispatch("setInstallationMaxDates", {
      start_date: this.installation.audit_start_date,
      end_date: this.installation.audit_end_date,
    });
    this.$store.dispatch("setInstallationAuditDate", {
      start_date: this.installation.audit_start_date,
      end_date: this.installation.audit_end_date,
    });
    this.$store.dispatch("setInstallationExpertDate", {
      start_date: this.installation.audit_start_date,
      end_date: this.installation.audit_end_date,
    });
  },

  computed: {
    ...mapGetters(["role", "installations", "cur_install_id", "constants"]),

    expertName() {
      const experts = {
        _ombrage_: "_ombrage_",
        _salissure_apparente_: "_salissure_apparente_",
        _masque_: "_masque_",
      };

      return experts[this.selected_mode];
    },

    isWarningCondition() {
      const result = Math.abs(1 - this.list_dashboard.nb_de_site);
      return result != 0 && this.dateRange === this.maxDate;
    },
    helioModes() {
      return [
        ...this.modes,
        ...this.helioExpertModules.map((module) => module.report_name),
      ];
    },
    helioExpertModules() {
      return this.expertModules.filter((module) =>
        ["ombrage", "encrassement", "masque"].includes(module.report_name)
      );
    },
    isHelioExpertModule() {
      return this.helioExpertModules.some(
        (module) => module.report_name === this.selected_mode
      );
    },
  },

  methods: {
    initinstallation() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");

      this.installations.forEach((element) => {
        if (element.installation_id == this.cur_install_id) {
          this.installation = element;
        }
      });

      this.dates[0] = this.installation.audit_start_date;
      this.dates[1] = `${year}-${month}-${day}`;
      this.updateDateRange();
      this.setdates();
    },
    resetToMaxDate() {
      this.dateRange = this.maxDate;
      this.tempDateRange = this.maxDate;
      this.isDateModified = false;
      this.isDateModifiedHistorie = false;
      this.takedades();
    },

    setInstallation() {
      this.installation = this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      );

      webconf.debugLog(
        "methods",
        this.script_name,
        "setInstallation",
        this.installation
      );
    },

    setDefaultDateToYesterday() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const defaultDate = yesterday.toISOString().slice(0, 10);
      if (!this.selectedDate) {
        this.dateRange = defaultDate;
        this.tempDateRange = defaultDate;
      } else {
        this.dateRange = this.selectedDate;
        this.tempDateRange = this.selectedDate;
      }
    },

    async getChecklistStatus() {
      if (this.$store.getters.cur_install_id !== undefined) {
        await api
          .getChecklistStatus(
            this.$store.getters.cur_install_id,
            this.dateRange
          )
          .then((res) => {
            this.checklistStatus = res.data;
          });
      }
    },

    async take_list_parc() {
      let elm = [];
      elm.push(this.cur_install_id);
      //this.site = elm;
      // Ensure list_fleet is updated with the correct data
      this.list_dashboard = { ...this.defaultDashboard };
      if (elm.length > 0) {
        try {
          const response = await api.getlistClean({
            fleet: elm,
            dates: this.dateRange,
            country_lang_code: this.$root.$i18n.locale,
          });
          this.list_fleet = response.data || [];
          this.list_dashboard = response.data.total
            ? { ...response.data.total }
            : { ...this.defaultDashboard };
        } catch (error) {
          console.error("Error fetching getlistfleet:", error);
          this.list_fleet = [];
          this.list_dashboard = {};
        }
      }
      if (elm.length > 0) {
        try {
          const response_alarm = await api.getlistcleanalarms({
            alarms: elm,
            dates: this.dateRange,
            country_lang_code: this.$root.$i18n.locale,
          });
          this.list_alarms = response_alarm.data || [];
        } catch (error) {
          console.error("Error fetching getlistalarms:", error);
          this.list_alarms = [];
        }
      }

      let majorAlarms = 0;
      let minorAlarms = 0;

      this.list_alarms.forEach((alarm) => {
        switch (alarm.criticity_info) {
          case "_critique_":
            majorAlarms += 1;
            break;

          case "_severe_":
            minorAlarms += 1;
            break;
        }
      });

      const withoutAlarms = majorAlarms === 0 && minorAlarms === 0 ? 1 : 0;

      this.list_dashboard = {
        ...this.list_dashboard,
        major_alarms: majorAlarms,
        minor_alarms: minorAlarms,
        without_alarms: withoutAlarms,
      };

      const currentHour = new Date().getHours();
      if (this.dateRange === this.maxDate) {
        if (currentHour >= 0 && currentHour <= 7) {
          this.color_warning_msg = "orange";
          this.warning_error_msg = `Données en cours d’acquisition`;
          this.showAlert = true;
        } else if (currentHour >= 8) {
          this.color_warning_msg = "#ff0000";
          this.warning_error_msg = `Données manquantes pour ce site `;
          this.showAlert = true;
        }
      }
    },

    takedades() {
      localStorage.date = this.tempDateRange;
      this.dateRange = this.tempDateRange;
      this.menu = false;
      this.take_list_parc();
      this.getChecklistStatus();
    },

    updateDateRange() {
      if (!this.dates || this.dates.length === 0) {
        this.dateRange_two = "";
        return;
      }

      if (!this.dates[1]) {
        // Only update the HISTORY date — NOT the main date
        this.dateRange_two = `${this.dates[0]} -> ${this.dates[0]}`;
        return;
      }

      // Sort and store normally
      let [start, end] = this.dates.sort((a, b) => new Date(a) - new Date(b));
      this.dateRange_two = `${start} -> ${end}`;
    },

    setdates() {
      this.$store.dispatch("setInstallationAuditDate", {
        start_date: this.dates[0],
        end_date: this.dates[1],
      });
    },

    validatedate() {
      this.menu_two = false;
      this.updateDateRange();
      this.setdates();
    },
    async getReportModules() {
      this.expertModules = [];

      const installation = this.installation;

      if (!installation) return;

      const res = await api.getReportModuleList(
        "expert-mod",
        installation.compute_tag_version
      );

      res.data.forEach((elm) => {
        if (
          elm.module_type.includes("expert-img") &&
          elm.target_menu.includes(installation.target_menu)
        ) {
          this.expertModules.push({
            text: this.$t(elm.module_name),
            report_name: elm.report_name,
            to: `/expert-img/${this.cur_install_id}/${elm.report_name}`,
            analysis_types: elm.analysis_types,
          });
        }

        if (
          elm.module_type.includes("expert-layout") &&
          elm.target_menu.includes(installation.target_menu)
        ) {
          this.expertModules.push({
            text: this.$t(elm.module_name),
            report_name: elm.report_name,
            to: `/expert-layout/${this.cur_install_id}/${elm.report_name}`,
            analysis_types: elm.analysis_types,
          });
        }

        if (
          elm.module_type.includes("expert-mod") &&
          elm.target_menu.includes(installation.target_menu)
        ) {
          this.expertModules.push({
            text: this.$t(elm.module_name),
            report_name: elm.report_name,
            to: `/expert-mod/${this.cur_install_id}/${elm.module_name}`,
            analysis_types: elm.analysis_types,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
}
.d-flex.align-center {
  min-height: 0px; /* adjust as needed */
  min-width: auto;
}
.date_selector_smart {
  width: 200px;
  margin-left: 80px;
  margin-bottom: 10px;
  position: relative; /* Important for absolute children */
}

.alert-wrapper {
  position: relative; /* contains the icon and alert */
}

.alert-icon {
  position: absolute;
  top: 5px; /* adjust vertical placement */
  left: -30px; /* adjust horizontal placement */
  cursor: pointer;
}

.alert-popup {
  position: absolute;
  top: 40px; /* distance from icon */
  left: -20px;
  width: 400px;
  z-index: 10;
}

.fleet-date-smart .v-input__slot {
  min-height: 40px !important; /* Force standard Vuetify height */
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
}

::v-deep .fleet-date-smart .v-text-field__details {
  display: none !important;
  margin: 0 !important;
  padding: 0 !important;
  min-height: 0 !important;
}
.v-menu__content {
  min-width: 290px !important;
}

.v-application a {
  text-decoration: none;
}

.v-chip {
  cursor: pointer;
}

.input {
  border: 1px solid #ededed !important;
  border-radius: 5px;
  cursor: pointer;
  padding: 1px 10px;
}

.mode-choice {
  text-transform: capitalize;
  font-size: 18px;
  padding: 8px 20px;
  font-weight: 500;
  border-radius: 4px 4px 0 0;
}

.mode-choice.active {
  background-color: white;
  cursor: default;
}

.mode-choice:not(.active) {
  background-color: rgba(100%, 100%, 100%, 0.5);
  cursor: pointer;
}
.mode-choice-site_middle {
  text-transform: capitalize;
  font-size: 18px;
  padding: 8px 20px;
  font-weight: 500;
  border-radius: 4px 4px 0 0;
}

.mode-choice-site_middle.active {
  background-color: white;
  cursor: default;
}

.mode-choice-site_middle:not(.active) {
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}
</style>

<style>
/* Target the ID directly to increase priority */
#content.v-main {
  padding-top: 64px !important;
}
</style>
